// src/components/blog/features/ShareFeatures/ShareWrapper.tsx

'use client'

import { usePathname } from 'next/navigation'
import { FloatingShare } from '~/components/blog/features/ShareFeatures/FloatingShare'

interface ShareWrapperProps {
  title: string
  baseUrl?: string
}

export function ShareWrapper({ title, baseUrl = 'https://www.adsights.ai' }: ShareWrapperProps): JSX.Element {
  const pathname = usePathname()
  const url = `${baseUrl}${pathname}`

  return <FloatingShare title={title} url={url} />
} 